export const SPECIAL_UNITS_LIST_FIELDS = `
    _id
    title
    unitsCount
    effectiveDateFrom
    effectiveDateTo
    units {
        commission {
            input
            value
        }
        createdBy {
            fullName
        }
        createdAt
        _id
        description
        lastModifiedOn
        stockNumber
        hierarchy
        isParent
        search
        criteria
        inventoryList {
            _id
            hierarchy
            isParent
            inventory {
                _id
                createdAt
                locationId
                status
                properties {
                    displayName
                    dataType
                    value
                }
                updatedAt
                averageAge
            }
        }
    }
    createdBy {
        fullName
    }
    createdAt
    lastModifiedBy {
        fullName
    }
    lastModifiedOn
`;
